import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Dropdown } from "antd";
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import React, { useState } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";

const QuizHandler = (props) => {
  const {
    hasAssignmentPlanPage,
    currentUser,
    assignmentPlanFromIndex,
    hasUnitExamPlanPage,
    unitExamPageIndex,
  } = props?.states;
  const {
    setAssignmentPlanModal,
    setAssignmentPageindex,
    setUnitExamPlanModal,
    setUnitExamPageindex,
  } = props?.funcObj;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {checkPopUpAtOnce} = usePopUpAtOnce();

  const handlerQuizPlan = () => {
    setAssignmentPlanModal(true);
    setAssignmentPageindex(assignmentPlanFromIndex);
  };
  const handlerUnitExam = () => {
    setUnitExamPlanModal(true);
    setUnitExamPageindex(unitExamPageIndex);
  };

  const checkQuiz = hasAssignmentPlanPage && currentUser?.role !== "student";
  const checkUnitExam = hasUnitExamPlanPage && currentUser?.role !== "student";

  const quizNav = {
    items: [
      {
        key: 'quiz',
        label: (
          <PaddedBtn
            onClick={(e) => {
              if(checkPopUpAtOnce()) return;
              e.preventDefault();
              handlerQuizPlan();
              setIsDropdownOpen(false);
            }}
          >
           Quiz
          </PaddedBtn>
        ),
        style: { padding: "0px" },
        className: "contextCenter"
      },
      {
        key: 'unitExam',
        label: (
          <PaddedBtn
            onClick={(e) => {
              if(checkPopUpAtOnce()) return;
              e.preventDefault();
              handlerUnitExam();
              setIsDropdownOpen(false);
            }}
          >
            Unit Exam
          </PaddedBtn>
        ),
        style: { padding: "0px" },
        className: "contextCenter"
      }
    ],
    onClick: () => {}
  };

  return (
    <>
      {checkQuiz && !checkUnitExam ? (
        <AssignmentPlan onClick={handlerQuizPlan}>
          <AssignmentPlanInner>Quiz</AssignmentPlanInner>
        </AssignmentPlan>
      ) : null}

      {!checkQuiz && checkUnitExam ? (
        <AssignmentPlan onClick={handlerUnitExam}>
          <AssignmentPlanInner>Unit Quiz</AssignmentPlanInner>
        </AssignmentPlan>
      ) : null}

      {checkQuiz && checkUnitExam && (
        <Dropdown
          menu={quizNav}
          placement="bottomLeft"
          trigger={["click"]}
          getPopupContainer={(trigger) => trigger.parentNode}
          onOpenChange={(visible) => setIsDropdownOpen(visible)}
        >
          <AssignmentPlan>
            <AssignmentPlanInner>
              Quiz {isDropdownOpen ? <KeyboardArrowUp style={{ marginRight: -5 }}/> : <KeyboardArrowDown style={{ marginRight: -5 }} />}
            </AssignmentPlanInner>
          </AssignmentPlan>
        </Dropdown>
      )}
    </>
  );
};

export default QuizHandler;

const PaddedBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  outline: none;
  padding: 8px;
  text-align: left;
  width: 100%;
`;

const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;

const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;
